// extracted by mini-css-extract-plugin
export default {"fontSize11":"QuestionComments_fontSize11__3rNPX","commentList":"QuestionComments_commentList__1wVY+"};